const COUNTRY_SET = 'EXPERIENCE_COUNTRY_SET';
const COUNTRY_SET_VALIDATION_MESSAGE = 'EXPERIENCE_COUNTRY_SET_VALIDATION_MESSAGE';
const COUNTRY_SET_VISUALIZATION = 'EXPERIENCE_COUNTRY_SET_VISUALIZATION';
const COUNTRY_SET_API_ERROR = 'EXPERIENCE_COUNTRY_SET_API_ERROR';
const COUNTRY_SET_FOCUS = 'EXPERIENCE_COUNTRY_SET_FOCUS';
const COUNTRY_BLURRED = 'EXPERIENCE_COUNTRY_BLURRED';
const COUNTRY_FOCUSED = 'EXPERIENCE_COUNTRY_FOCUSED';
const COUNTRY_CHANGE = 'EXPERIENCE_COUNTRY_CHANGE';
const COUNTRY_GET_SUGGESTIONS = 'EXPERIENCE_COUNTRY_GET_SUGGESTIONS';
const COUNTRY_SET_SUGGESTIONS = 'EXPERIENCE_COUNTRY_SET_SUGGESTIONS';
const COUNTRY_SUGGESTIONS_ERROR = 'EXPERIENCE_COUNTRY_SUGGESTIONS_ERROR';
const COUNTRY_SET_ID = 'EXPERIENCE_COUNTRY_SET_ID';

const countrySet = (value) => ({
  type: COUNTRY_SET,
  payload: {
    value
  }
});

const countrySetValidationMessage = (validationMessage) => ({
  type: COUNTRY_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const countrySetVisualization = (markedAsWrong) => ({
  type: COUNTRY_SET_VISUALIZATION,
  payload: {
    markedAsWrong
  }
});

const countrySetApiError = (payload) => ({
  type: COUNTRY_SET_VISUALIZATION,
  payload
});

const countrySetFocus = (focus) => ({
  type: COUNTRY_SET_FOCUS,
  payload: {
    focus
  }
});

const countryBlur = ({ value, suggestions, validationMessage, highlightedSuggestion }) => ({
  type: COUNTRY_BLURRED,
  payload: {
    value,
    suggestions,
    validationMessage,
    highlightedSuggestion
  }
});

const countryFocus = () => ({
  type: COUNTRY_FOCUSED
});

const countryChange = (payload) => ({
  type: COUNTRY_CHANGE,
  payload
});

const countrySuggestionsGet = (query) => ({
  type: COUNTRY_GET_SUGGESTIONS,
  payload: {
    query
  }
});

const countrySuggestionsSet = (suggestions) => ({
  type: COUNTRY_SET_SUGGESTIONS,
  payload: {
    suggestions
  }
});

const countrySuggestionsError = () => ({
  type: COUNTRY_SUGGESTIONS_ERROR
});

const countrySetId = (id) => ({
  type: COUNTRY_SET_ID,
  payload: {
    id
  }
});

export {
  countrySetValidationMessage,
  countrySetVisualization,
  countryFocus,
  countrySetFocus,
  countrySetApiError,
  countryBlur,
  countrySet,
  countryChange,
  countrySuggestionsGet,
  countrySuggestionsSet,
  countrySuggestionsError,
  countrySetId,
  COUNTRY_SET_ID,
  COUNTRY_SUGGESTIONS_ERROR,
  COUNTRY_SET_SUGGESTIONS,
  COUNTRY_GET_SUGGESTIONS,
  COUNTRY_CHANGE,
  COUNTRY_FOCUSED,
  COUNTRY_BLURRED,
  COUNTRY_SET_FOCUS,
  COUNTRY_SET_API_ERROR,
  COUNTRY_SET_VALIDATION_MESSAGE,
  COUNTRY_SET,
  COUNTRY_SET_VISUALIZATION
};

